import ROUTES from '@lib/constants/routes';
import COLORS from 'lib/constants/colors';
import Link from 'next/link';
import styled from 'styled-components';

const Anchor = styled.a`
  display: inline-block;
  text-decoration: none;
  font-size: 12px;
  color: #929292;
  border-radius: 100px;
  padding: 2px 8px 3px;
  transition: all 0.2s ease-in;
  background-color: #ececec;
  border-color: #ececec;
  margin-right: 4px;

  :hover {
    background-color: ${COLORS.pink};
    border-color: ${COLORS.pink};
    color: #fff;
  }
`;

const CategoryLink = ({
  category,
}: {
  category: {
    uid: string;
    slug: string;
  };
}) => (
  <Link key={category?.uid} href={ROUTES.blogCategory(category.uid)}>
    <Anchor>{category?.slug}</Anchor>
  </Link>
);

export default CategoryLink;
